export default function (other) {
  other = other || {}
  return {
    name: other.name || null,
    active: other.active != null ? other.active : true,
  }
}
